export enum AllowedStoreTypeEnum {
  ALL = "ALL",
  ALLOWED_MANAGE_STORE = "ALLOWED_MANAGE_STORE",
  ALLOWED_STORE_REPORT = "ALLOWED_STORE_REPORT",
  ORDER = "ORDER",
  CUSTOMER = "CUSTOMER",
  PAYMENT = "PAYMENT"
}
